import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classes from './registrationSuccess.module.css';
import Header from '../../components/standartComponents/header';

const RegistrationSuccess = ({ authUser }) => {
  const navigate = useNavigate();

  return (
    <>
      <Header authUser={authUser} />
      
      <div className={classes.wrap}>
        {/* HERO */}
        <div className={classes.hero}>
          <div className={classes.heroIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
          </div>
          <h1>Вітаємо{authUser?.displayName ? `, ${authUser.displayName}` : ''}! Акаунт створено</h1>
          <p>Тепер ваш прогрес, словник і навчальні плани будуть зберігатися.</p>
          <div className={classes.choose}>Оберіть, як хочете почати навчання.</div>
        </div>

        <div className={classes.secLabel}>Як хочете навчатися?</div>

        {/* CARDS */}
        <div className={classes.cards}>
          {/* Primary: Create Plan */}
          <div className={`${classes.card} ${classes.cardPrimary}`} onClick={() => navigate('/survey')}>
            <div className={classes.cardBadge}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z"/></svg>
              Рекомендовано
            </div>
            <div className={`${classes.cardIcon} ${classes.ci1}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
            </div>
            <h3>Отримати персональний план</h3>
            <div className={classes.desc}>Ми створимо курс під вашу ціль, рівень і тему навчання.</div>
            <div className={classes.cardBullets}>
              <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Структурований шлях уроків</div>
              <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Video → Words → Quiz → Speaking</div>
              <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Прогрес і результати зберігаються</div>
            </div>
            <button className={`${classes.cardCta} ${classes.ctaP}`}>
              Створити мій план 
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </button>
          </div>

          {/* Secondary: Self Study */}
          <div className={classes.card} onClick={() => navigate('/catalog')}>
            <div className={`${classes.cardIcon} ${classes.ci2}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>
            </div>
            <h3>Навчатися без плану</h3>
            <div className={classes.desc}>Обирайте будь-які відео та практикуйтеся у власному темпі.</div>
            <div className={classes.cardBullets}>
              <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Будь-яка тема</div>
              <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Без фіксованого порядку</div>
              <div className={classes.cb}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Можна перейти до плану пізніше</div>
            </div>
            <button className={`${classes.cardCta} ${classes.ctaS}`}>
              Перейти до відео 
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </button>
          </div>
        </div>

        {/* REASSURANCE */}
        <div className={classes.reassure}>
          <div className={classes.reassureTitle}>Ви зможете змінити режим пізніше</div>
          <div className={classes.reassureItems}>
            <div className={classes.ri}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
              Якщо почнете без плану, зможете створити персональний курс у будь-який момент.
            </div>
            <div className={classes.ri}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
              Якщо створите план, зможете також дивитися відео самостійно.
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default RegistrationSuccess;
